import * as z from "zod/v4";

export const logPrintQueue = {
  name: "logPrintQueue" as const,
  input: z.object({
    queue: z.array(
      z.object({
        batch: z.union([
          z.object({ fulfillmentGroupIds: z.array(z.string()) }),
          z.object({ batchId: z.string() }),
        ]),
        document: z.string(),
        printOptions: z.object({
          idempotencyKey: z.string().nullish(),
          printerId: z.number().nullish(),
          templateId: z.string().nullish(),
          printFast: z.boolean().nullish(),
          printerOptions: z.any().nullish(),
        }),
      }),
    ),
    queueIndex: z.number(),
  }),
  output: z.object({ success: z.boolean() }),
};
